"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { GraduationCap, Briefcase, Plane, Home, Building2, FileText,  } from "lucide-react";


const services = [
  {
    icon: <GraduationCap size={22} className="text-[#B8893A]" />,
    title: "International Operations",
    description: 
      "Offshore companies are ideal for businesses operating globally with no requirement for UAE-based operations.",
    href: "/services",
  },
  {
    icon: <Briefcase size={22} className="text-[#B8893A]" />,
    title: "Asset Protection",
    description: 
      "Not all jurisdictions are the same. We guide you to the best option: Mainland for full UAE market access, Free Zone for 100% ownership and tax efficiency, Offshore for international operations.",
    href: "/services",
  },
  {
    icon: <Plane size={22} className="text-[#B8893A]" />,
    title: "100% Foreign Ownership",
    description: 
      "Full ownership with complete control over your company structure and shareholding.",
    href: "/services",
  },
  {
    icon: <Home size={22} className="text-[#B8893A]" />,
    title: "0% Corporate & Income Tax",
    description: 
      "Pay no corporate or personal income taxes on your offshore company profits.",
    href: "/services",
  },
  {
    icon: <Building2 size={22} className="text-[#B8893A]" />,
    title: "No Physical Office Required",
    description:
      "Offshore companies do not require a physical UAE office space or local presence.",
    href: "/services",
  },
  {
    icon: <FileText size={22} className="text-[#B8893A]" />,
    title: "Confidentiality",
    description: 
      "UAE offshore structures offer strong privacy protections for shareholders and directors.",
    href: "/services",
  },
];

export default function WhychooseOffshore() {
  return (
    <section className="py-14 sm:py-16 lg:py-20 xl:py-14 2xl:py-28 px-4 sm:px-6 lg:px-14 bg-[#FAFAFA]">

      {/* 🔥 SUPER CONTAINER (BIG SCREEN FIX) */}
      <div className="w-full mx-auto 
        max-w-[1300px] 
        lg:max-w-[1500px] 
        xl:max-w-[1700px] 
        2xl:max-w-[2000px] 
        3xl:max-w-[2200px]">

        {/* HEADER */}
        <div className="text-center mb-14 sm:mb-16 lg:mb-20 xl:mb-24 max-w-5xl mx-auto">
          <p className="text-xs sm:text-sm lg:text-base font-semibold tracking-[0.15em] uppercase text-[#B8893A] mb-3 sm:mb-4">
            What We Do
          </p>

          <h2 
            className="font-bold text-[#000000] leading-tight mb-4 sm:mb-5"
            style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: "700", lineHeight: "1.3" }}
          >
            Every Service Your Business <span className="text-[#000000]">Needs</span>
          </h2>

          <p 
            className="text-gray-500"
            style={{ fontSize: "clamp(14px, 1.2vw, 16px)", lineHeight: "1.6" }}
          >
            From incorporation to growth, we cover the full lifecycle of your business in the UAE.
          </p>
        </div>

        {/* GRID */}
        <div className="grid 
          grid-cols-1 
          sm:grid-cols-2 
          lg:grid-cols-3 
          xl:grid-cols-3 
          2xl:grid-cols-3 
          3xl:grid-cols-3 
          gap-5 sm:gap-6 lg:gap-7 xl:gap-5">

          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              className="group bg-[#fafafa] border border-gray-100 rounded-xl sm:rounded-[16px] p-5 sm:p-6 lg:p-7 shadow-xl transition-all duration-300"
            >

              {/* TOP ROW */}
              <div className="flex items-start justify-between mb-4">

                <h3 
                  className="font-semibold text-black group-hover:text-[#B8893A] transition"
                  style={{ fontSize: "clamp(16px, 1.8vw, 18px)", fontWeight: "600" }}
                >
                  {service.title}
                </h3>

                <div className="text-black/30 group-hover:text-[#B8893A] transition">
                  {service.icon}
                </div>

              </div>

              {/* LINE */}
              <div className="h-px bg-gray-100 my-6"></div>

              {/* DESCRIPTION */}
              <p 
                className="text-gray-500 mb-6"
                style={{ fontSize: "clamp(13px, 1.1vw, 15px)", lineHeight: "1.6" }}
              >
                {service.description}
              </p>

           

            </motion.div>
          ))}

        </div>

        {/* CTA */}
        {/* <div className="text-center mt-10">
          <Link
            href="/services"
            className="inline-block px-6 sm:px-8 lg:px-10 py-3 sm:py-3.5 lg:py-4 rounded-xl bg-[#B8893A] text-white text-sm sm:text-base font-semibold transition-all hover:scale-105 hover:bg-[#A67B34]"
          >
            View All Services
          </Link>
        </div> */}

      </div>

      {/* BACKGROUND GLOW */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-[#B8893A]/5 blur-3xl rounded-full -z-10"></div>

    </section>
  );
}
